export var apis = {
  // Login
  login: 'login',
  // Reportes
  ejecuciones: 'sensos',
  binarios: 'reporte_binarios',
  reportes_de_cedis: 'reporte_trabajadors',
  // 
  cedis: 'trabajadors',
  categorias: 'categorias',
  sub_categorias: 'sub_categorias',
  evaluaciones: 'evaluacions',
  almacenistas: 'clientes',
  clientes: 'trabajadors',
  evaluadores: 'evaluadors',
  oficinas_de_ventas: 'oficina_de_ventas',
  areas_de_ventas: 'area_de_ventas',
}